module.exports = __webpack_public_path__ + "static/media/SOYBEANS_1x.0dfa2e95.png";